import { render } from "./MathProblems.vue?vue&type=template&id=65eb1eaa&bindings={\"checkAnswers\":\"options\"}"
import script from "./MathProblems.vue?vue&type=script&lang=js"
export * from "./MathProblems.vue?vue&type=script&lang=js"

import "./MathProblems.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script